import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=1a0c5948"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=1a0c5948&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports